import * as z from "zod";
import { requiredString } from "components/form/utils";

export const gradeSchema = z.object({
  name: requiredString(),
    status: z.optional(z.string()).default("draft"),
});
